import { Case } from 'services';
export const CaseChatMock: Case[] = [
  {
    id: 'CC-001',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Chat',
      subjectValue: `{"output":[{"type":"imageCarousel","value":[{"type":"imageUrl","value":{"value":"https://t10pugc.blob.core.windows.net/retailugc/2533275015656578/11/1/1/5b44ccaf-9bf4-4c47-ab71-a86901b6e213/8?sv=2018-03-28&sr=b&sig=FRS8OLPnOSr%2F7Luc9FhKtU%2FG%2FUC5q7tfWjw%2FkucsJ08%3D&se=2021-11-16T07%3A18%3A07Z&sp=r"}},{"type":"imageUrl","value":{"value":"https://t10pugc.blob.core.windows.net/retailugc/2533275015656578/11/1/1/5b44ccaf-9bf4-4c47-ab71-a86901b6e213/4?sv=2018-03-28&sr=b&sig=103jLzAzkSTxP7mxudDe3jeeEAXloBlePZjxHY6Lo%2BQ%3D&se=2021-11-16T07%3A18%3A07Z&sp=r"}}]}]}`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          userType: 'Mixer',
          username: 'BlestShark'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CC-002',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Chat',
      subjectValue: `{"output":[{"type":"imageUrl","value":{"value":"https://t10pugc.blob.core.windows.net/retailugc/2533275015656578/11/1/1/5b44ccaf-9bf4-4c47-ab71-a86901b6e213/8?sv=2018-03-28&sr=b&sig=FRS8OLPnOSr%2F7Luc9FhKtU%2FG%2FUC5q7tfWjw%2FkucsJ08%3D&se=2021-11-16T07%3A18%3A07Z&sp=r"}},{"type":"imageUrl","value":{"value":"https://t10pugc.blob.core.windows.net/retailugc/2533275015656578/11/1/1/5b44ccaf-9bf4-4c47-ab71-a86901b6e213/4?sv=2018-03-28&sr=b&sig=103jLzAzkSTxP7mxudDe3jeeEAXloBlePZjxHY6Lo%2BQ%3D&se=2021-11-16T07%3A18%3A07Z&sp=r"}}]}`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Mixer'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CC-003',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: 'LFG\\93ac0100-efec-488c-af85-e5850ff4b5bd\\global(lfg)\\c473e276-a63f-4463-9664-b7b94edd6a75',
      subjectType: 'Chat',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"Sus babysitter need 1 babysitter 2 parents im the kid the baby sitter NEEDS to be THIC i use text to speech"}},{"type":"headerValue","value":{"header":"Tags","value":"Rp, anotherTag, moreTag"}}]}',
      subjectLabels: ['Looking For Group'],
      subjectOwners: [
        {
          userId: '2535461707815405',
          userType: 'Xuid',
          userTraits: []
        }
      ],
      subjectHashes: {
        text:
          'Sus babysitter need 1 babysitter 2 parents im the kid the baby sitter NEEDS to be THIC i use text to speech'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CC-004',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Chat',
      subjectValue: `{
        "output": [
          {
            "type": "video",
            "value": {
              "url": "https://www.w3schools.com/tags/movie.ogg",
              "frames": [
                { "time": 1, "image": "https://www.w3schools.com/html/pic_trulli.jpg", "trait": "house" },
                { "time": 5, "image": "https://www.w3schools.com/html/img_chania.jpg", "trait": "trait" },
                { "time": 10, "image": "https://www.w3schools.com/html/img_chania.jpg", "trait": "trait" }
              ]
            }
          },
          {
            "type": "headerValue",
            "value": { "header": "Reported Message", "value": "Example message" }
          },
          { "type": "br", "value": null },
          {
            "type": "table",
            "value": [
              { "text1": "Date", "text2": "Name", "text3": "Message" },
              {
                "text1": "2020-02-26 22:02:09Z",
                "text2": "C0MPI0NE",
                "text3": "quality so bad need to help get better gear"
              },
              {
                "text1": "2020-02-26 22:02:16Z",
                "text2": "ClaimingMold481",
                "text3": "Jk"
              },
              {
                "text1": "2020-02-26 22:02:36Z",
                "text2": "Gibbyn",
                "text3": "Get banned chump"
              },
              { "text1": "2020-02-26 22:03:10Z", "text2": "Gibbyn", "text3": "Oh" },
              {
                "text1": "2020-02-26 22:03:18Z",
                "text2": "BlestShark",
                "text3": "My day is going to get worse"
              },
              {
                "text1": "2020-02-26 22:03:34Z",
                "text2": "hesser69",
                "text3": "lol there just dumb"
              },
              {
                "text1": "2020-02-26 22:03:43Z",
                "text2": "BlestShark",
                "text3": "Yup"
              },
              {
                "text1": "2020-02-26 22:03:49Z",
                "text2": "BlestShark",
                "text3": "😭😭😭😭😭😭😭"
              },
              {
                "text1": "2020-02-26 22:04:04Z",
                "text2": "hesser69",
                "text3": "they honestly have nothing else to do with their lives"
              },
              {
                "text1": "2020-02-26 22:04:20Z",
                "text2": "Gibbyn",
                "text3": "Eat meatballs with me"
              },
              {
                "text1": "2020-02-26 22:04:26Z",
                "text2": "BlestShark",
                "text3": "They can"
              },
              {
                "text1": "2020-02-26 22:04:39Z",
                "text2": "BlestShark",
                "text3": "***Example message***"
              },
              {
                "text1": "2020-02-26 22:05:05Z",
                "text2": "BlestShark",
                "text3": "😭😭😭😭😭😭😭"
              }
            ]
          }
        ]
      }`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          userType: 'Mixer',
          username: 'BlestShark'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CC-005',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Chat',
      subjectValue: `{
        "output": [
          {
            "type": "video",
            "value": {
              "url": "https://www.w3schools.com/tags/movie.ogg",
              "frames": [
                { "time": 1, "image": "https://www.w3schools.com/html/pic_trulli.jpg", "trait": "house" },
                { "time": 5, "image": "https://www.w3schools.com/html/img_chania.jpg", "trait": "trait" },
                { "time": 10, "image": "https://www.w3schools.com/html/img_chania.jpg", "trait": "trait" }
              ]
            }
          }
        ]
      }`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Mixer'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CC-006',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Chat',
      subjectValue: `{
        "output": [
          {
            "type": "audioUrl",
            "value": "https://file-examples-com.github.io/uploads/2017/11/file_example_WAV_1MG.wav"
          }
        ]
      }`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Mixer'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
export const CaseChatTestMock: Case[] = [
  {
    id: 'CCT-001',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ChatTest',
      subjectValue: `{"output":[{"type":"imageCarousel","value":[{"type":"imageUrl","value":{"value":"https://t10pugc.blob.core.windows.net/retailugc/2533275015656578/11/1/1/5b44ccaf-9bf4-4c47-ab71-a86901b6e213/8?sv=2018-03-28&sr=b&sig=FRS8OLPnOSr%2F7Luc9FhKtU%2FG%2FUC5q7tfWjw%2FkucsJ08%3D&se=2021-11-16T07%3A18%3A07Z&sp=r"}},{"type":"imageUrl","value":{"value":"https://t10pugc.blob.core.windows.net/retailugc/2533275015656578/11/1/1/5b44ccaf-9bf4-4c47-ab71-a86901b6e213/4?sv=2018-03-28&sr=b&sig=103jLzAzkSTxP7mxudDe3jeeEAXloBlePZjxHY6Lo%2BQ%3D&se=2021-11-16T07%3A18%3A07Z&sp=r"}}]}]}`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          userType: 'Mixer',
          username: 'BlestShark'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CCT-002',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ChatTest',
      subjectValue: `{"output":[{"type":"imageUrl","value":{"value":"https://t10pugc.blob.core.windows.net/retailugc/2533275015656578/11/1/1/5b44ccaf-9bf4-4c47-ab71-a86901b6e213/8?sv=2018-03-28&sr=b&sig=FRS8OLPnOSr%2F7Luc9FhKtU%2FG%2FUC5q7tfWjw%2FkucsJ08%3D&se=2021-11-16T07%3A18%3A07Z&sp=r"}},{"type":"imageUrl","value":{"value":"https://t10pugc.blob.core.windows.net/retailugc/2533275015656578/11/1/1/5b44ccaf-9bf4-4c47-ab71-a86901b6e213/4?sv=2018-03-28&sr=b&sig=103jLzAzkSTxP7mxudDe3jeeEAXloBlePZjxHY6Lo%2BQ%3D&se=2021-11-16T07%3A18%3A07Z&sp=r"}}]}`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Mixer'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CCT-003',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: 'LFG\\93ac0100-efec-488c-af85-e5850ff4b5bd\\global(lfg)\\c473e276-a63f-4463-9664-b7b94edd6a75',
      subjectType: 'ChatTest',
      subjectValue:
        '{"output":[{"type":"headerValue","value":{"header":"Description","value":"Sus babysitter need 1 babysitter 2 parents im the kid the baby sitter NEEDS to be THIC i use text to speech"}},{"type":"headerValue","value":{"header":"Tags","value":"Rp, anotherTag, moreTag"}}]}',
      subjectLabels: ['Looking For Group'],
      subjectOwners: [
        {
          userId: '2535461707815405',
          userType: 'Xuid',
          userTraits: []
        }
      ],
      subjectHashes: {
        text:
          'Sus babysitter need 1 babysitter 2 parents im the kid the baby sitter NEEDS to be THIC i use text to speech'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CCT-004',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ChatTest',
      subjectValue: `{
        "output": [
          {
            "type": "video",
            "value": {
              "url": "https://www.w3schools.com/tags/movie.ogg",
              "frames": [
                { "time": 1, "image": "https://www.w3schools.com/html/pic_trulli.jpg", "trait": "house" },
                { "time": 5, "image": "https://www.w3schools.com/html/img_chania.jpg", "trait": "trait" },
                { "time": 10, "image": "https://www.w3schools.com/html/img_chania.jpg", "trait": "trait" }
              ]
            }
          },
          {
            "type": "headerValue",
            "value": { "header": "Reported Message", "value": "Example message" }
          },
          { "type": "br", "value": null },
          {
            "type": "table",
            "value": [
              { "text1": "Date", "text2": "Name", "text3": "Message" },
              {
                "text1": "2020-02-26 22:02:09Z",
                "text2": "C0MPI0NE",
                "text3": "quality so bad need to help get better gear"
              },
              {
                "text1": "2020-02-26 22:02:16Z",
                "text2": "ClaimingMold481",
                "text3": "Jk"
              },
              {
                "text1": "2020-02-26 22:02:36Z",
                "text2": "Gibbyn",
                "text3": "Get banned chump"
              },
              { "text1": "2020-02-26 22:03:10Z", "text2": "Gibbyn", "text3": "Oh" },
              {
                "text1": "2020-02-26 22:03:18Z",
                "text2": "BlestShark",
                "text3": "My day is going to get worse"
              },
              {
                "text1": "2020-02-26 22:03:34Z",
                "text2": "hesser69",
                "text3": "lol there just dumb"
              },
              {
                "text1": "2020-02-26 22:03:43Z",
                "text2": "BlestShark",
                "text3": "Yup"
              },
              {
                "text1": "2020-02-26 22:03:49Z",
                "text2": "BlestShark",
                "text3": "😭😭😭😭😭😭😭"
              },
              {
                "text1": "2020-02-26 22:04:04Z",
                "text2": "hesser69",
                "text3": "they honestly have nothing else to do with their lives"
              },
              {
                "text1": "2020-02-26 22:04:20Z",
                "text2": "Gibbyn",
                "text3": "Eat meatballs with me"
              },
              {
                "text1": "2020-02-26 22:04:26Z",
                "text2": "BlestShark",
                "text3": "They can"
              },
              {
                "text1": "2020-02-26 22:04:39Z",
                "text2": "BlestShark",
                "text3": "***Example message***"
              },
              {
                "text1": "2020-02-26 22:05:05Z",
                "text2": "BlestShark",
                "text3": "😭😭😭😭😭😭😭"
              }
            ]
          }
        ]
      }`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          userType: 'Mixer',
          username: 'BlestShark'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CCT-005',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ChatTest',
      subjectValue: `{
        "output": [
          {
            "type": "video",
            "value": {
              "url": "https://www.w3schools.com/tags/movie.ogg",
              "frames": [
                { "time": 1, "image": "https://www.w3schools.com/html/pic_trulli.jpg", "trait": "house" },
                { "time": 5, "image": "https://www.w3schools.com/html/img_chania.jpg", "trait": "trait" },
                { "time": 10, "image": "https://www.w3schools.com/html/img_chania.jpg", "trait": "trait" }
              ]
            }
          }
        ]
      }`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Mixer'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CCT-006',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'ChatTest',
      subjectValue: `{
        "output": [
          {
            "type": "audioUrl",
            "value": "https://file-examples-com.github.io/uploads/2017/11/file_example_WAV_1MG.wav"
          }
        ]
      }`,
      subjectLabels: ['Chat Message'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Mixer'
        }
      ],
      subjectHashes: {
        text: 'Example message'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
